export function validateOneToSix(value) {
  const num = parseInt(value, 10);
  if (isNaN(num) || num < 1 || num > 6) {
    return "Value must be between 1 and 6";
  }
  return true;
}
export function validateTimeLines(value){
  const num = parseInt(value, 10);
  if (isNaN(num)|| num < 1 || num > 6000){
    return "Value must be between 1 and 6000";
  }
  return true;
}

export function validateDungeonTimeLines(value){
  const num = parseInt(value, 10);
  if (isNaN(num)|| num < 1 || num > 300){
    return "Value must be between 1 and 300";
  }
  return true;
}

export function validateDungeonAge(value){
  const num = parseInt(value, 10);
  if (isNaN(num)|| num < 1 || num > 10){
    return "Value must be between 1 and 10";
  }
  return true;
}